<template>
  <div id="app" class="container-fluid" tabindex="0" v-on:keyup.right.prevent="refresh"
  v-on:keyup.down.prevent="addCU">
    <b-row >
      <b-col cols="12" class="header">
        <img alt="Raiffeisen" src="./assets/raiffeisen-logo.png" class="logo float-right">
        <img alt="Contexity" src="./assets/contexity-logo-boxed.png" class="logo float-right">
        <!--<img alt="Contexity" src="./assets/contexity-logo.png" class="logo float-right">-->
        <h1><!-- <img alt="Contexity" src="./assets/contexity-logo-white.png" class="clogo">--> smartCC</h1>
        <span class="subtitle">AI empowered customer service</span>
      </b-col>
    </b-row>

    <OpenDialogs v-if="!selectedDialog"></OpenDialogs>
    <ActiveDialog v-if="selectedDialog"></ActiveDialog>

<!--
    <b-icon icon="check-circle" font-scale="3" variant="primary"></b-icon>
    <b-icon icon="person" font-scale="3" variant="secondary"></b-icon>
    <b-icon icon="chat-fill" font-scale="3" variant="info"></b-icon>
    <b-icon icon="person-fill" font-scale="3" variant="warning"></b-icon>
    <b-icon icon="pencil" font-scale="3"></b-icon>
    <b-icon icon="toggle-on" font-scale="3"></b-icon>
    <b-icon icon="wallet" font-scale="3"></b-icon>
    <b-icon icon="archive" font-scale="3"></b-icon>
    <b-icon icon="archive-fill" font-scale="3"></b-icon>
    <b-icon icon="x-circle" font-scale="3"></b-icon>
    <b-icon icon="x-square" font-scale="3"></b-icon>
    <b-icon icon="calendar" font-scale="3"></b-icon>
    <b-icon icon="credit-card" font-scale="3"></b-icon>
    <b-icon icon="question" font-scale="3"></b-icon>
    <b-icon icon="list-check" font-scale="3"></b-icon>
    <b-icon icon="search" font-scale="3"></b-icon>
    <b-icon icon="house" font-scale="3"></b-icon>
    <b-icon icon="chat-fill" font-scale="3"></b-icon>
    <b-icon icon="card-heading" font-scale="3"></b-icon>
    <b-icon icon="clipboard-data" font-scale="3"></b-icon>
    <b-icon icon="columns" font-scale="3"></b-icon>
    <b-icon icon="cloud-upload" font-scale="3"></b-icon>
    <b-icon icon="layout-wtf" font-scale="3"></b-icon>
    <b-icon icon="view-list" font-scale="3"></b-icon>
-->

  </div>
</template>

<script>
import ActiveDialog from '@/components/ActiveDialog'
import OpenDialogs from '@/components/OpenDialogs'

export default {
  name: 'App',

  components: {
    ActiveDialog,
    OpenDialogs
  },
  created: function () {
      this.$store.dispatch('authenticate');
  },
  computed: {
    selectedDialog() {
      return this.$store.state.dialog;
    },
    error () {
      return this.$store.state.error;
    }
  },
  methods: {
    refresh () {
      this.$store.dispatch('getDialog');
      this.$store.dispatch('getDialogState');
    },
    addCU () {
      this.$store.dispatch('addClientUtterance');
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/custom.scss';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
}

.logo {
  font-family: "Maven Pro";
  //max-width: 220px;
  max-height: 100px;
  //margin-bottom: 5px;
  margin-left: 5px;
}
.clogo {
  max-height: 26px;
  margin-bottom: 3px;
}
.nav-item a {
  color: #2d97ba;
  font-weight: 700 !important;
}
ol li a {
  color: #2d97ba;
}
ol li.active {
  font-weight: 700;
}
.btn-primary {
    color: #fff;
    background-color: #2d97ba !important;
    border-color: #2d97ba !important;
}
.nav-item a.disabled {
  color: #ccc !important;
}
.header {
  padding-top: 10px;
  padding-bottom: 40px;
  background: url("./assets/banner.png");
  background-size: cover;
  height: 120px;
  margin-bottom: 20px;
}
.header h1 {
  color: #fff;
  font-family: "Maven Pro";
  font-size: 2.4rem;
  margin-left: 1rem;
  margin-top:10px;
}
.header .subtitle {
  color: #fff;
  font-family: "Maven Pro";
  font-weight: 300;
  font-size: 1.2rem;
  line-height: 16px;
  margin-left: 1rem;
}
.form-control.highlight {
  background-color: #FBF3E8 !important;
}
.card-body.highlight {
  background-color: #FBF3E8 !important;
}
.table-primary, .table-primary > td {
  background-color: #bee5eb !important;
  border-color: #2d97ba !important;
  opacity: 1;
  color: #0c5460;
}
.nav-item a {
  font-weight: 500;
}
.card-header {
  font-weight: 700;
}
</style>
